import calculatePPrivatePremiaQuery from '~/domains/offer/__gql__/queries/calculatePPrivatePremia.gql'
import createPPrivatePolicyMutation from '~/domains/offer/__gql__/mutations/createPPrivatePolicy.gql'
import calculatePMovePremiaQuery from '~/domains/offer/__gql__/queries/calculatePMovePremia.gql'
import createPMovePolicyMutation from '~/domains/offer/__gql__/mutations/createPMovePolicy.gql'
import calculatePCombiPremiaQuery from '~/domains/offer/__gql__/queries/calculatePCombiPremia.gql'
import createPCombiPolicyMutation from '~/domains/offer/__gql__/mutations/createPCombiPolicy.gql'
import calculateBBusinessPremiaQuery from '~/domains/offer/__gql__/queries/calculateBBusinessPremia.gql'
import createBBusinessPolicyMutation from '~/domains/offer/__gql__/mutations/createBBusinessPolicy.gql'
import calculateSmallBusinessPremiaQuery from '~/domains/offer/__gql__/queries/calculateSBSmallBusinessPremia.gql'
import createSmallBusinessPolicyMutation from '~/domains/offer/__gql__/mutations/createSBSmallBusinessPolicy.gql'
import calculateBMovePremiaQuery from '~/domains/offer/__gql__/queries/calculateBMovePremia.gql'
import createBMovePolicyMutation from '~/domains/offer/__gql__/mutations/createBMovePolicy.gql'

export default {
  // P-PRIVATE -----------------------------------------------------------------------
  async CALC_PPRIVATE_PREMIA(context, payload) {
    const formData = {
      ...payload,
      // eslint-disable-next-line max-len
      numberOfApartmentsForRentInSwitzerland: parseInt(
        payload.numberOfApartmentsForRentInSwitzerland,
        10,
      ),
    }
    try {
      context.commit('LOADING', true)
      const result = await this.app.apolloProvider.defaultClient.query({
        query: calculatePPrivatePremiaQuery,
        variables: {
          formData,
        },
      })
      if (result.data && result.data.calculatePPrivatePremia) {
        const { calculatePPrivatePremia } = result.data

        if (!calculatePPrivatePremia.validationErrors.length) {
          const premia = {
            insurable: calculatePPrivatePremia.insurable,
            components: calculatePPrivatePremia.premia || [],
            totalPremium: calculatePPrivatePremia.totalPremium
              ? {
                  value: calculatePPrivatePremia.totalPremium.value,
                  currency: calculatePPrivatePremia.totalPremium.currency,
                }
              : {},
          }
          context.commit('SET_PREMIA', premia)
        }

        return calculatePPrivatePremia
      }
      return false
    } catch (error) {
      console.error(error)
      return false
    } finally {
      context.commit('LOADING', false)
    }
  },
  async CREATE_PPRIVATE_POLICY(context, payload) {
    const {
      privateBasicQuestions,
      policyHolderData,
      assessmentQuestions,
    } = context.state
    const questionnaire = {
      ...privateBasicQuestions,
      // eslint-disable-next-line max-len
      numberOfApartmentsForRentInSwitzerland: parseInt(
        privateBasicQuestions.numberOfApartmentsForRentInSwitzerland,
        10,
      ),
    }
    const broker = {
      brokerId: payload.brokerId ? payload.brokerId : null,
      origin: payload.origin ? payload.origin : null,
    }
    try {
      context.commit('LOADING', true)
      const result = await this.app.apolloProvider.defaultClient.mutate({
        mutation: createPPrivatePolicyMutation,
        variables: {
          questionnaire,
          policyholder: policyHolderData,
          riskQuestions: assessmentQuestions,
          brokerId: broker.brokerId,
          origin: broker.origin,
        },
      })
      if (result.data && result.data.createPPrivatePolicy) {
        return result.data.createPPrivatePolicy
      }
      return false
    } catch (error) {
      console.error(error)
      return false
    } finally {
      context.commit('LOADING', false)
    }
  },

  // P-MOVE -----------------------------------------------------------------------
  async CALC_PMOVE_PREMIA(context, payload) {
    const formData = {
      ...payload,
    }
    delete formData.apartmentsRentedInSwitzerland
    delete formData.numberOfApartmentsForRentInSwitzerland
    try {
      context.commit('LOADING', true)
      const result = await this.app.apolloProvider.defaultClient.query({
        query: calculatePMovePremiaQuery,
        variables: {
          formData,
        },
      })
      if (result.data && result.data.calculatePMovePremia) {
        const { calculatePMovePremia } = result.data

        if (!calculatePMovePremia.validationErrors.length) {
          const premia = {
            insurable: calculatePMovePremia.insurable,
            components: calculatePMovePremia.premia || [],
            totalPremium: calculatePMovePremia.totalPremium
              ? {
                  value: calculatePMovePremia.totalPremium.value,
                  currency: calculatePMovePremia.totalPremium.currency,
                }
              : {},
          }
          context.commit('SET_PREMIA', premia)
        }

        return calculatePMovePremia
      }
      return false
    } catch (error) {
      console.error(error)
      return false
    } finally {
      context.commit('LOADING', false)
    }
  },
  async CREATE_PMOVE_POLICY(context, payload) {
    const {
      privateBasicQuestions,
      policyHolderData,
      assessmentQuestions,
    } = context.state
    const questionnaire = {
      ...privateBasicQuestions,
    }
    delete questionnaire.apartmentsRentedInSwitzerland
    delete questionnaire.numberOfApartmentsForRentInSwitzerland
    const broker = {
      brokerId: payload.brokerId ? payload.brokerId : null,
      origin: payload.origin ? payload.origin : null,
    }
    try {
      context.commit('LOADING', true)
      const result = await this.app.apolloProvider.defaultClient.mutate({
        mutation: createPMovePolicyMutation,
        variables: {
          questionnaire,
          policyholder: policyHolderData,
          riskQuestions: assessmentQuestions,
          brokerId: broker.brokerId,
          origin: broker.origin,
        },
      })
      if (result.data && result.data.createPMovePolicy) {
        return result.data.createPMovePolicy
      }
      return false
    } catch (error) {
      console.error(error)
      return false
    } finally {
      context.commit('LOADING', false)
    }
  },

  // P-COMBI -----------------------------------------------------------------------
  async CALC_PCOMBI_PREMIA(context, payload) {
    const formData = {
      ...payload,
      // eslint-disable-next-line max-len

      numberOfApartmentsForRentInSwitzerland: parseInt(
        payload.numberOfApartmentsForRentInSwitzerland,
        10,
      ),
    }
    try {
      context.commit('LOADING', true)
      const result = await this.app.apolloProvider.defaultClient.query({
        query: calculatePCombiPremiaQuery,
        variables: {
          formData,
        },
      })
      if (result.data && result.data.calculatePCombiPremia) {
        const { calculatePCombiPremia } = result.data

        if (!calculatePCombiPremia.validationErrors.length) {
          const premia = {
            insurable: calculatePCombiPremia.insurable,
            components: calculatePCombiPremia.premia || [],
            totalPremium: calculatePCombiPremia.totalPremium
              ? {
                  value: calculatePCombiPremia.totalPremium.value,
                  currency: calculatePCombiPremia.totalPremium.currency,
                }
              : {},
          }
          context.commit('SET_PREMIA', premia)
        }

        return calculatePCombiPremia
      }
      return false
    } catch (error) {
      console.error(error)
      return false
    } finally {
      context.commit('LOADING', false)
    }
  },
  async CREATE_PCOMBI_POLICY(context, payload) {
    const {
      privateBasicQuestions,
      policyHolderData,
      assessmentQuestions,
    } = context.state
    const questionnaire = {
      ...privateBasicQuestions,
      // eslint-disable-next-line max-len
      numberOfApartmentsForRentInSwitzerland: parseInt(
        privateBasicQuestions.numberOfApartmentsForRentInSwitzerland,
        10,
      ),
    }
    const broker = {
      brokerId: payload.brokerId ? payload.brokerId : null,
      origin: payload.origin ? payload.origin : null,
    }
    try {
      context.commit('LOADING', true)
      const result = await this.app.apolloProvider.defaultClient.mutate({
        mutation: createPCombiPolicyMutation,
        variables: {
          questionnaire,
          policyholder: policyHolderData,
          riskQuestions: assessmentQuestions,
          brokerId: broker.brokerId,
          origin: broker.origin,
        },
      })
      if (result.data && result.data.createPCombiPolicy) {
        return result.data.createPCombiPolicy
      }
      return false
    } catch (error) {
      console.error(error)
      return false
    } finally {
      context.commit('LOADING', false)
    }
  },

  // B-BUSINESS -----------------------------------------------------------------------
  async CALC_BBUSINESS_PREMIA(context, payload) {
    const formData = {
      ...payload,
      estimatedAnnualPayroll: {
        currency: 'CHF',
        value:
          parseFloat(payload.estimatedAnnualPayroll.replace(',', '.')) || 0,
      },
      estimatedAnnualSales: {
        currency: 'CHF',
        value: parseFloat(payload.estimatedAnnualSales.replace(',', '.')) || 0,
      },
    }
    try {
      context.commit('LOADING', true)
      const result = await this.app.apolloProvider.defaultClient.query({
        query: calculateBBusinessPremiaQuery,
        variables: {
          formData,
        },
      })
      if (result.data && result.data.calculateBBusinessPremia) {
        const { calculateBBusinessPremia } = result.data

        if (!calculateBBusinessPremia.validationErrors.length) {
          const premia = {
            insurable: calculateBBusinessPremia.insurable,
            components: calculateBBusinessPremia.premia || [],
            totalPremium: calculateBBusinessPremia.totalPremium
              ? {
                  value: calculateBBusinessPremia.totalPremium.value,
                  currency: calculateBBusinessPremia.totalPremium.currency,
                }
              : {},
          }
          context.commit('SET_PREMIA', premia)
        }

        return calculateBBusinessPremia
      }
      return false
    } catch (error) {
      console.error(error)
      return false
    } finally {
      context.commit('LOADING', false)
    }
  },
  async CREATE_BBUSINESS_POLICY(context, payload) {
    const {
      businessBasicQuestions,
      businessPolicyHolderData,
      assessmentQuestions,
    } = context.state
    const questionnaire = {
      ...businessBasicQuestions,
      estimatedAnnualPayroll: {
        currency: 'CHF',
        value:
          parseFloat(
            businessBasicQuestions.estimatedAnnualPayroll.replace(',', '.'),
          ) || 0,
      },
      estimatedAnnualSales: {
        currency: 'CHF',
        value:
          parseFloat(
            businessBasicQuestions.estimatedAnnualSales.replace(',', '.'),
          ) || 0,
      },
    }
    delete businessPolicyHolderData.contactPerson.address
    const broker = {
      brokerId: payload.brokerId ? payload.brokerId : null,
      origin: payload.origin ? payload.origin : null,
    }
    try {
      context.commit('LOADING', true)
      const result = await this.app.apolloProvider.defaultClient.mutate({
        mutation: createBBusinessPolicyMutation,
        variables: {
          questionnaire,
          policyholder: businessPolicyHolderData,
          riskQuestions: assessmentQuestions,
          brokerId: broker.brokerId,
          origin: broker.origin,
        },
      })
      if (result.data && result.data.createBBusinessPolicy) {
        return result.data.createBBusinessPolicy
      }
      return false
    } catch (error) {
      console.error(error)
      return false
    } finally {
      context.commit('LOADING', false)
    }
  },

  // B-MOVE -----------------------------------------------------------------------
  async CALC_BMOVE_PREMIA(context, payload) {
    const formData = {
      ...payload,
      countStreetVehicles: parseInt(payload.countStreetVehicles, 10) || 0,
      countWaterVehicles: parseInt(payload.countWaterVehicles, 10) || 0,
    }
    try {
      context.commit('LOADING', true)
      const result = await this.app.apolloProvider.defaultClient.query({
        query: calculateBMovePremiaQuery,
        variables: {
          formData,
        },
      })
      if (result.data && result.data.calculateBMovePremia) {
        const { calculateBMovePremia } = result.data

        if (!calculateBMovePremia.validationErrors.length) {
          const premia = {
            insurable: calculateBMovePremia.insurable,
            components: calculateBMovePremia.premia || [],
            totalPremium: calculateBMovePremia.totalPremium
              ? {
                  value: calculateBMovePremia.totalPremium.value,
                  currency: calculateBMovePremia.totalPremium.currency,
                }
              : {},
          }
          context.commit('SET_PREMIA', premia)
        }

        return calculateBMovePremia
      }
      return false
    } catch (error) {
      console.error(error)
      return false
    } finally {
      context.commit('LOADING', false)
    }
  },
  async CREATE_BMOVE_POLICY(context, payload) {
    const {
      businessMoveBasicQuestions,
      businessPolicyHolderData,
      assessmentQuestions,
    } = context.state
    const questionnaire = {
      ...businessMoveBasicQuestions,
      countStreetVehicles:
        parseInt(businessMoveBasicQuestions.countStreetVehicles, 10) || 0,
      countWaterVehicles:
        parseInt(businessMoveBasicQuestions.countWaterVehicles, 10) || 0,
    }
    delete businessPolicyHolderData.contactPerson.address
    const broker = {
      brokerId: payload.brokerId ? payload.brokerId : null,
      origin: payload.origin ? payload.origin : null,
    }
    try {
      context.commit('LOADING', true)
      const result = await this.app.apolloProvider.defaultClient.mutate({
        mutation: createBMovePolicyMutation,
        variables: {
          questionnaire,
          policyholder: businessPolicyHolderData,
          riskQuestions: assessmentQuestions,
          brokerId: broker.brokerId,
          origin: broker.origin,
        },
      })
      if (result.data && result.data.createBMovePolicy) {
        return result.data.createBMovePolicy
      }
      return false
    } catch (error) {
      console.error(error)
      return false
    } finally {
      context.commit('LOADING', false)
    }
  },

  // SMALL-BUSINESS -----------------------------------------------------------------------
  async CALC_SMALLBUSINESS_PREMIA(context, payload) {
    const formData = {
      ...payload,
      estimatedAnnualPayroll: {
        currency: 'CHF',
        value:
          parseFloat(payload.estimatedAnnualPayroll.replace(',', '.')) || 0,
      },
      estimatedAnnualSales: {
        currency: 'CHF',
        value: parseFloat(payload.estimatedAnnualSales.replace(',', '.')) || 0,
      },
    }
    try {
      context.commit('LOADING', true)
      const result = await this.app.apolloProvider.defaultClient.query({
        query: calculateSmallBusinessPremiaQuery,
        variables: {
          formData,
        },
      })
      if (result.data && result.data.calculateSBSmallBusinessPremia) {
        const {
          calculateSBSmallBusinessPremia: calculateSmallBusinessPremia,
        } = result.data

        if (!calculateSmallBusinessPremia.validationErrors.length) {
          const premia = {
            insurable: calculateSmallBusinessPremia.insurable,
            components: calculateSmallBusinessPremia.premia || [],
            totalPremium: calculateSmallBusinessPremia.totalPremium
              ? {
                  value: calculateSmallBusinessPremia.totalPremium.value,
                  currency: calculateSmallBusinessPremia.totalPremium.currency,
                }
              : {},
          }
          context.commit('SET_PREMIA', premia)
        }

        return calculateSmallBusinessPremia
      }
      return false
    } catch (error) {
      console.error(error)
      return false
    } finally {
      context.commit('LOADING', false)
    }
  },
  async CREATE_SMALLBUSINESS_POLICY(context, payload) {
    const {
      businessBasicQuestions,
      businessPolicyHolderData,
      assessmentQuestions,
    } = context.state
    const questionnaire = {
      ...businessBasicQuestions,
      estimatedAnnualPayroll: {
        currency: 'CHF',
        value:
          parseFloat(
            businessBasicQuestions.estimatedAnnualPayroll.replace(',', '.'),
          ) || 0,
      },
      estimatedAnnualSales: {
        currency: 'CHF',
        value:
          parseFloat(
            businessBasicQuestions.estimatedAnnualSales.replace(',', '.'),
          ) || 0,
      },
    }
    const broker = {
      brokerId: payload.brokerId ? payload.brokerId : null,
      origin: payload.origin ? payload.origin : null,
    }
    try {
      context.commit('LOADING', true)
      const result = await this.app.apolloProvider.defaultClient.mutate({
        mutation: createSmallBusinessPolicyMutation,
        variables: {
          questionnaire,
          policyholder: businessPolicyHolderData,
          riskQuestions: assessmentQuestions,
          brokerId: broker.brokerId,
          origin: broker.origin,
        },
      })
      if (result.data && result.data.createSBSmallBusinessPolicy) {
        return result.data.createSBSmallBusinessPolicy
      }
      return false
    } catch (error) {
      console.error(error)
      return false
    } finally {
      context.commit('LOADING', false)
    }
  },
}
